import { useLDFlags } from './useLDFlags';

export interface ShoppingBagFlagStatusType {
  isVariant: boolean;
  isControl: boolean;
  isV1: boolean;
  isV2: boolean;
}

export function useLDNewShoppingBagUX() {
  const {
    'show-new-ui-ux-on-mini-cart-and-shopping-bag':
      showNewUiUxOnMiniCartAndShoppingBag,
  } = useLDFlags();

  if (!showNewUiUxOnMiniCartAndShoppingBag) {
    return {
      isControl: true,
      isVariant: false,
      isV1: false,
      isV2: false,
    };
  }

  return {
    isControl: showNewUiUxOnMiniCartAndShoppingBag === 'control',
    isVariant: showNewUiUxOnMiniCartAndShoppingBag !== 'control',
    isV1: showNewUiUxOnMiniCartAndShoppingBag === 'variant1',
    isV2: showNewUiUxOnMiniCartAndShoppingBag === 'variant2',
  };
}
